/*
 * Copyright © 2020-2026 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2026-01-26 14:30:44
 */
import React from 'react'
import classNames from 'classnames'
import { usePayment } from '../../../app/hooks'
import { useButtonText, useVipTypeDisabled } from '../hooks'
import type { Member } from '../constants'
import NewBadge from './NewBadge'

export interface MemberCardProps {
  member: Member
  active?: boolean
  setHoverKind?: (kind: number | null) => void
  handleEventTrack: (clickItem: string, vipKind?: number) => void
}

export default function MemberCard({
  member,
  active,
  setHoverKind,
  handleEventTrack
}: MemberCardProps) {
  const { title, subTitle, price, vipKind, priceSuffix, features } = member
  const { openVipByKind } = usePayment()
  const disabled = useVipTypeDisabled(member)
  const buttonText = useButtonText(member)

  const handleButtonClick = () => {
    handleEventTrack('开通或升级', vipKind)
    openVipByKind(vipKind, 'webVIPSummary')
  }

  return (
    <div
      className={classNames('memberCard', {
        active: active && !disabled
      })}
      onMouseEnter={() => {
        if (!disabled && setHoverKind) {
          setHoverKind(vipKind)
        }
      }}
    >
      <div className="cardHeader">
        <div className="cardTitle">{title}</div>
        <div className="cardSubTitle">{subTitle}</div>
        <div className="cardPrice">
          <span className="priceValue">{price}</span>
          <span className="priceSuffix">{priceSuffix}</span>
        </div>
        <button
          className="cardButton"
          disabled={disabled}
          onClick={handleButtonClick}
        >
          {buttonText}
        </button>
      </div>
      <div className="cardFeatures">
        {features.map((feature, index) => (
          <div key={index} className="featureItem">
            <div className="featureLabel">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
              >
                <path
                  d="M11 4.125C14.797 4.125 17.875 7.20304 17.875 11C17.875 14.797 14.797 17.875 11 17.875C7.20304 17.875 4.125 14.797 4.125 11C4.125 7.20304 7.20304 4.125 11 4.125ZM10.3125 12.0898L8.25 10.0273L7.27734 11L10.3125 14.0352L14.7227 9.625L13.75 8.65234L10.3125 12.0898Z"
                  fill="#E0906D"
                />
              </svg>
              {feature.label}
              {feature.isNew && <NewBadge />}
            </div>
            <div className="featureValue">{feature.value}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
